import React, { Component } from 'react'
import InitializedApp from './InitializedApp.js'
import WsContainers from './shared/WsContainers.js'
import { getCustomUISDK } from './shared/customUiSdk.js'
import LoadingCircle from './shared/LoadingCircle.js'
import { generateSessionId, getCookieLanguage, getCookies, errorLogEnabled, setCookie } from './shared/Utils.js'
import Translate from './shared/Translate.js'

class App extends Component {

  constructor(props) {
    super(props)
    let state = {
      connected: false,
      sdk: null,
      callToNumber: null,
    }
    const urlParams = new URLSearchParams(window.location.search)
    const userId = urlParams.get('userId') || ''
    // state.companyId = urlParams.get('companyId') || ''
    // state.token = urlParams.get('token') || ''
    // check sessionId in cookies and set the new id if not present
    var sessionId = getCookies()['sessionId']
    if (!sessionId) {
      // set new sessionId in cookies
      sessionId = setCookie('sessionId', generateSessionId(), 365)
    }
    // this.setState({ credentials: { userId: this.state.credentials.userId, sessionId: sessionId } })
    state.credentials = { userId: userId, sessionId: sessionId }
    this.state = state
  }

  async componentDidMount() {
    WsContainers.onStateChange((state) => {
      this.setState({ connected: state })
    })

    Translate.onStateChange((language, _) => {
      this.setState({ language: language })
    })

    WsContainers.init()
    try {
      const sdk = await getCustomUISDK()
      this.setState({ sdk: sdk })
    } catch (error) {
      errorLogEnabled && console.error("Error initializing SDK:", error)
    }

    Translate.init(getCookieLanguage(), (language) => {
      return Translate.loadFile(language, '/lang/' + language + '.json')
    })
  }

  render() {
    if (!this.state.connected || !this.state.credentials || !this.state.sdk) {
      return <LoadingCircle />
    }
    return <InitializedApp sdk={this.state.sdk} credentials={this.state.credentials} callToNumber={this.state.callToNumber} />
  }
}

export default App